/**
 * Format an ISO date string into a readable format
 * @param isoDate
 * @param locale
 *
 * @example
 * formatISODate('2023-10-01T12:00:00Z', 'en'); // "October 1, 2023"
 * formatISODate('2023-10-01T12:00:00Z', 'fr'); // "1 octobre 2023"
 */
export const formatISODate = (isoDate: string, locale: 'fr' | 'en'): string => {
  const date = new Date(isoDate);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleDateString(locale, options);
};
